import { Button, Tooltip } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";

interface WizardButtonProps {
  title: string;
  onClick: () => void;

  disabled?: boolean;
  type?: "primary" | "secondary";
  tooltip?: string;
}

const WizardButton = ({
  title,
  onClick,

  tooltip = "",
  disabled = false,
  type = "primary",
}: WizardButtonProps) => {
  const btnClassnames = classNames(styles.wizardButton, {
    [styles.primary]: type === "primary",
    [styles.secondary]: type === "secondary",
  });

  return (
    <Tooltip title={tooltip}>
      <Button className={btnClassnames} onClick={onClick} disabled={disabled}>
        {title}
      </Button>
    </Tooltip>
  );
};

export default WizardButton;
